<template>
    <span v-if="attribution" class="marketing-attribution-line inline-flex items-center gap-2">
        <UiBadge :color="attribution.channel_color ?? 'gray'">{{ attribution.channel_label }}</UiBadge>
        <span v-if="attribution.campaign_label" class="marketing-attribution-line__campaign">{{
            attribution.campaign_label
        }}</span>
    </span>
</template>

<script setup lang="ts">
interface AttributionPayload {
    channel_label: string;
    channel_color: string | null;
    campaign_label: string | null;
    display_line: string;
    utm_source: string | null;
    utm_medium: string | null;
    utm_campaign: string | null;
    utm_term: string | null;
    utm_content: string | null;
    gclid: string | null;
    fbclid: string | null;
    msclkid: string | null;
    gad_campaignid: string | null;
    gbraid: string | null;
    wbraid: string | null;
    referrer: string | null;
    landing_url: string | null;
    captured_at: string | null;
}

defineProps<{
    attribution: AttributionPayload | null | undefined;
}>();
</script>
